/* OH, MADE! — theme.js (vanilla, no dependencies) */
(() => {
  'use strict';
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const T = window.theme || { routes: {}, strings: {} };
  const S = T.strings || {};
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const finePointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  const CART_SECTIONS = ['cart-drawer', 'cart-count'];

  const formatMoney = (cents) => '$' + (Number(cents || 0) / 100).toLocaleString('en-AU', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  const debounce = (fn, ms) => { let t; return (...a) => { clearTimeout(t); t = setTimeout(() => fn(...a), ms); }; };
  const fmt = (str, vars) => String(str || '').replace(/{{\s*(\w+)\s*}}|\[(\w+)\]/g, (m, a, b) => (vars[a || b] ?? m));

  /* ---------------- toast ---------------- */
  let toastTimer;
  function toast(msg) {
    const el = $('.toast');
    if (!el) return;
    el.textContent = msg;
    el.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => { el.hidden = true; }, 3200);
  }

  /* ---------------- drawers ---------------- */
  let lastTrigger = null;
  const focusables = (el) => $$('a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), textarea, select, [tabindex]:not([tabindex="-1"])', el).filter((n) => n.offsetParent !== null);
  function openDrawer(el, trigger) {
    if (!el) return;
    lastTrigger = trigger || document.activeElement;
    el.classList.add('is-open');
    el.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    if (trigger && trigger.hasAttribute('aria-expanded')) trigger.setAttribute('aria-expanded', 'true');
    const panel = $('.drawer__panel', el) || el;
    if (!panel.hasAttribute('tabindex')) panel.setAttribute('tabindex', '-1');
    setTimeout(() => panel.focus({ preventScroll: true }), 60);
  }
  function closeDrawer(el) {
    if (!el || !el.classList.contains('is-open')) return;
    el.classList.remove('is-open');
    el.setAttribute('aria-hidden', 'true');
    if (!$('.drawer.is-open') && !$('.search-overlay.is-open')) document.documentElement.style.overflow = '';
    $$('[aria-expanded="true"][data-drawer-open]').forEach((b) => b.setAttribute('aria-expanded', 'false'));
    if (lastTrigger && document.contains(lastTrigger)) lastTrigger.focus({ preventScroll: true });
  }
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      $$('.drawer.is-open').forEach(closeDrawer);
      closeSearch();
      $$('.site-nav details[open]').forEach((d) => d.removeAttribute('open'));
    }
    if (e.key === 'Tab') {
      const open = $('.drawer.is-open .drawer__panel') || $('.search-overlay.is-open .search-overlay__panel');
      if (!open) return;
      const f = focusables(open);
      if (!f.length) return;
      if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
      else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
    }
  });
  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-drawer-open]');
    if (opener) { e.preventDefault(); openDrawer(document.getElementById(opener.dataset.drawerOpen), opener); return; }
    const closer = e.target.closest('[data-drawer-close]');
    if (closer) { closeDrawer(closer.closest('.drawer')); return; }
    const cartLink = e.target.closest('[data-cart-open]');
    if (cartLink && T.cartType === 'drawer' && $('#CartDrawer')) { e.preventDefault(); openDrawer($('#CartDrawer'), cartLink); return; }
    // close desktop dropdowns when clicking outside
    $$('.site-nav details[open]').forEach((d) => { if (!d.contains(e.target)) d.removeAttribute('open'); });
  });
  // only one desktop dropdown at a time
  $$('.site-nav details').forEach((d) => d.addEventListener('toggle', () => { if (d.open) $$('.site-nav details[open]').forEach((o) => { if (o !== d) o.removeAttribute('open'); }); }));

  /* ---------------- header ---------------- */
  const headerWrap = $('[data-header]');
  if (headerWrap) {
    const header = $('.site-header', headerWrap);
    const mode = headerWrap.dataset.sticky;
    if (mode === 'none') headerWrap.style.position = 'relative';
    let lastY = window.scrollY;
    const onScroll = () => {
      const y = window.scrollY;
      header.classList.toggle('is-scrolled', y > 4);
      if (mode === 'on-scroll-up') {
        const hide = y > 240 && y > lastY && !$('.site-nav details[open]');
        headerWrap.classList.toggle('is-hidden', hide);
      }
      lastY = y;
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------------- announcement ---------------- */
  $$('[data-announcement]').forEach((bar) => {
    const items = $$('.announcement__item', bar);
    if (items.length < 2 || reduced) return;
    let i = 0, paused = false;
    bar.addEventListener('mouseenter', () => { paused = true; });
    bar.addEventListener('mouseleave', () => { paused = false; });
    setInterval(() => {
      if (paused || document.hidden) return;
      items[i].classList.remove('is-active'); items[i].inert = true;
      i = (i + 1) % items.length;
      items[i].classList.add('is-active'); items[i].inert = false;
    }, (Number(bar.dataset.interval) || 5) * 1000);
  });

  /* ---------------- search overlay ---------------- */
  const overlay = $('[data-search-overlay]');
  function openSearch(trigger) {
    if (!overlay) return;
    lastTrigger = trigger;
    overlay.classList.add('is-open');
    document.documentElement.style.overflow = 'hidden';
    setTimeout(() => $('[data-predictive-input]', overlay).focus(), 50);
  }
  function closeSearch() {
    if (!overlay || !overlay.classList.contains('is-open')) return;
    overlay.classList.remove('is-open');
    if (!$('.drawer.is-open')) document.documentElement.style.overflow = '';
    if (lastTrigger) lastTrigger.focus({ preventScroll: true });
  }
  document.addEventListener('click', (e) => {
    const o = e.target.closest('[data-search-open]');
    if (o) { e.preventDefault(); openSearch(o); }
    if (e.target.closest('[data-search-close]')) closeSearch();
  });
  if (overlay) {
    const input = $('[data-predictive-input]', overlay);
    const results = $('[data-predictive-results]', overlay);
    const defaults = $('[data-predictive-default]', overlay);
    let controller;
    const run = debounce(async () => {
      const q = input.value.trim();
      if (!q) { results.innerHTML = ''; defaults.hidden = false; return; }
      defaults.hidden = true;
      controller && controller.abort();
      controller = new AbortController();
      try {
        const url = `${T.routes.predictiveSearch}?q=${encodeURIComponent(q)}&section_id=predictive-search&resources[type]=product,collection,page&resources[limit]=6&resources[options][prefix]=last`;
        const res = await fetch(url, { signal: controller.signal });
        const html = await res.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const inner = doc.querySelector('.shopify-section') || doc.body;
        results.innerHTML = inner.innerHTML;
      } catch (err) { if (err.name !== 'AbortError') results.innerHTML = ''; }
    }, 220);
    input.addEventListener('input', run);
  }

  /* ---------------- cart ---------------- */
  const cartDrawer = () => $('#CartDrawer');
  function applySections(sections) {
    if (!sections) return;
    if (sections['cart-drawer']) {
      const doc = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
      const fresh = doc.querySelector('#CartDrawer');
      const current = cartDrawer();
      if (fresh && current) {
        const scroll = $('.drawer__body', current)?.scrollTop || 0;
        current.querySelector('.drawer__panel').replaceWith(fresh.querySelector('.drawer__panel'));
        const body = $('.drawer__body', current);
        if (body) body.scrollTop = scroll;
      }
    }
    if (sections['cart-count']) {
      const doc = new DOMParser().parseFromString(sections['cart-count'], 'text/html');
      const fresh = doc.querySelector('[data-cart-count]');
      $$('[data-cart-count]').forEach((el) => {
        if (!fresh) return;
        el.innerHTML = fresh.innerHTML;
        el.hidden = fresh.hasAttribute('hidden');
        el.classList.remove('is-bumped'); void el.offsetWidth; el.classList.add('is-bumped');
      });
    }
  }
  async function cartRequest(url, body, isForm) {
    const opts = { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' } };
    if (isForm) opts.body = body;
    else { opts.headers['Content-Type'] = 'application/json'; opts.body = JSON.stringify(body); }
    const res = await fetch(url, opts);
    const data = await res.json();
    if (!res.ok || data.status) throw new Error(data.description || data.message || S.cartError);
    return data;
  }
  async function afterAdd(data) {
    if (T.cartType === 'drawer' && cartDrawer()) {
      applySections(data.sections);
      openDrawer(cartDrawer());
    } else {
      window.location.href = T.routes.cart;
    }
  }
  async function changeLine(line, quantity) {
    const item = $(`#CartDrawer .cart-item[data-line="${line}"]`) || $(`.cart-item[data-line="${line}"]`);
    item && item.classList.add('is-loading');
    try {
      const data = await cartRequest(`${T.routes.cartChange}.js`, { line: Number(line), quantity: Number(quantity), sections: CART_SECTIONS, sections_url: window.location.pathname });
      if (document.body.classList.contains('template-cart')) { window.location.reload(); return; }
      applySections(data.sections);
    } catch (err) { toast(err.message); item && item.classList.remove('is-loading'); }
  }
  document.addEventListener('click', (e) => {
    const minus = e.target.closest('[data-qty-minus]');
    const plus = e.target.closest('[data-qty-plus]');
    if (minus || plus) {
      const wrap = (minus || plus).closest('[data-qty]');
      const input = $('input', wrap);
      const min = Number(input.min || 0);
      const next = Math.max(min, Number(input.value || 0) + (plus ? 1 : -1));
      input.value = next;
      if (input.dataset.lineQty) changeLine(input.dataset.lineQty, next);
      else input.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }
    const remove = e.target.closest('[data-line-remove]');
    if (remove) { changeLine(remove.dataset.lineRemove, 0); return; }
    const quick = e.target.closest('[data-quick-add]');
    if (quick) {
      e.preventDefault();
      quick.classList.add('is-loading');
      cartRequest(`${T.routes.cartAdd}.js`, { items: [{ id: Number(quick.dataset.quickAdd), quantity: 1 }], sections: CART_SECTIONS, sections_url: window.location.pathname })
        .then(afterAdd).catch((err) => toast(err.message)).finally(() => quick.classList.remove('is-loading'));
    }
  });
  document.addEventListener('change', (e) => {
    const q = e.target.closest('[data-line-qty]');
    if (q) changeLine(q.dataset.lineQty, q.value);
  });
  const saveNote = debounce((value) => cartRequest(`${T.routes.cartUpdate}.js`, { note: value }).catch(() => {}), 500);
  document.addEventListener('input', (e) => { if (e.target.matches('[data-cart-note]')) saveNote(e.target.value); });

  /* ---------------- photo studio (photo magnets) ---------------- */
  // Decodes an image file with EXIF orientation applied; <img> fallback for browsers without createImageBitmap options.
  async function decodeImage(file) {
    if (window.createImageBitmap) {
      try {
        const bmp = await createImageBitmap(file, { imageOrientation: 'from-image' });
        return { src: bmp, w: bmp.width, h: bmp.height, release: () => bmp.close && bmp.close() };
      } catch (e) { /* fall back to <img> */ }
    }
    const url = URL.createObjectURL(file);
    const img = new Image();
    img.src = url;
    try { await img.decode(); } catch (e) { URL.revokeObjectURL(url); throw e; }
    return { src: img, w: img.naturalWidth, h: img.naturalHeight, release: () => URL.revokeObjectURL(url) };
  }
  // Cover-fits a photo (shot.w × shot.h) into a square of `size`, zoomed and centred on (cx, cy) — fractions of the photo.
  function placement(shot, size) {
    const k = (size / Math.min(shot.w, shot.h)) * shot.zoom;
    const dw = shot.w * k;
    const dh = shot.h * k;
    return {
      dw, dh,
      x: Math.min(0, Math.max(size - dw, size / 2 - shot.cx * dw)),
      y: Math.min(0, Math.max(size - dh, size / 2 - shot.cy * dh)),
    };
  }
  const PRINT_PX = 1500; // 5 cm magnet ≈ 760 dpi
  const MIN_SOURCE_PX = 600; // below this the crop prints soft (< 300 dpi)

  class PhotoStudio {
    constructor(page, dialog) {
      this.page = page;
      this.dialog = dialog;
      this.shots = [];
      this.active = -1;
      this.target = 1;
      this.maxBytes = (T.uploadMaxMb || 15) * 1024 * 1024;
      const q = (sel) => $(sel, dialog);
      this.canvas = q('[data-studio-canvas]');
      this.magnet = q('[data-studio-magnet]');
      this.empty = q('[data-studio-empty]');
      this.tools = q('[data-studio-tools]');
      this.hint = q('[data-studio-hint]');
      this.warn = q('[data-studio-warn]');
      this.zoom = q('[data-studio-zoom]');
      this.thumbs = q('[data-studio-thumbs]');
      this.input = q('[data-studio-input]');
      this.drop = q('[data-studio-drop]');
      this.count = q('[data-studio-count]');
      this.summary = q('[data-studio-summary]');
      this.share = q('[data-studio-share]');
      this.confirm = q('[data-studio-confirm]');
      this.ok = q('[data-studio-ok]');
      this.error = q('[data-studio-error]');
      this.addLabel = q('[data-studio-add-label]');
      this.buttons = $$('[data-studio-submit]', dialog);
      this.bind();
    }
    current() { return this.shots[this.active] || null; }
    say(msg) { this.error.textContent = msg || ''; this.error.hidden = !msg; }
    bind() {
      $$('[data-studio-close]', this.dialog).forEach((b) => b.addEventListener('click', () => this.close()));
      this.dialog.addEventListener('close', () => {
        if (!$('.drawer.is-open')) {
          document.documentElement.style.overflow = '';
          if (this.trigger && document.contains(this.trigger)) this.trigger.focus({ preventScroll: true });
        }
      });
      this.input.addEventListener('change', () => { this.addFiles(Array.from(this.input.files || [])); this.input.value = ''; });
      ['dragenter', 'dragover'].forEach((ev) => this.drop.addEventListener(ev, () => this.drop.classList.add('is-over')));
      ['dragleave', 'drop'].forEach((ev) => this.drop.addEventListener(ev, () => this.drop.classList.remove('is-over')));
      this.thumbs.addEventListener('click', (e) => {
        const rm = e.target.closest('[data-remove]');
        if (rm) { this.remove(Number(rm.dataset.remove)); return; }
        const pick = e.target.closest('[data-pick]');
        if (pick) this.select(Number(pick.dataset.pick));
      });
      this.zoom.addEventListener('input', () => this.adjust((s) => { s.zoom = Number(this.zoom.value); }));
      $('[data-studio-reset]', this.dialog).addEventListener('click', () => this.adjust((s) => Object.assign(s, { zoom: 1, cx: 0.5, cy: 0.5 })));
      this.share.addEventListener('change', () => { this.share.classList.remove('has-error'); this.say(''); });
      this.ok.addEventListener('change', () => { this.confirm.classList.remove('has-error'); this.say(''); });
      this.bindGestures();
      window.addEventListener('resize', debounce(() => { if (this.dialog.open) this.draw(); }, 120));
    }
    bindGestures() {
      const c = this.canvas;
      const pts = new Map();
      const centre = () => { let x = 0, y = 0; pts.forEach((p) => { x += p.x; y += p.y; }); return { x: x / pts.size, y: y / pts.size }; };
      const spread = () => { if (pts.size < 2) return 0; const [a, b] = [...pts.values()]; return Math.hypot(a.x - b.x, a.y - b.y); };
      c.addEventListener('pointerdown', (e) => {
        if (!this.current()) return;
        c.setPointerCapture(e.pointerId);
        pts.set(e.pointerId, { x: e.clientX, y: e.clientY });
      });
      c.addEventListener('pointermove', (e) => {
        if (!pts.has(e.pointerId)) return;
        const before = centre();
        const dist = spread();
        pts.set(e.pointerId, { x: e.clientX, y: e.clientY });
        const after = centre();
        const scale = c.width / (c.clientWidth || 1);
        this.adjust((s) => {
          if (dist) s.zoom = Math.min(3, Math.max(1, s.zoom * (spread() / dist)));
          const p = placement(s, c.width);
          s.cx -= ((after.x - before.x) * scale) / p.dw;
          s.cy -= ((after.y - before.y) * scale) / p.dh;
        });
      });
      const end = (e) => pts.delete(e.pointerId);
      ['pointerup', 'pointercancel', 'lostpointercapture'].forEach((ev) => c.addEventListener(ev, end));
      c.addEventListener('wheel', (e) => {
        if (!this.current()) return;
        e.preventDefault();
        this.adjust((s) => { s.zoom = Math.min(3, Math.max(1, s.zoom * Math.exp(-e.deltaY * 0.0015))); });
      }, { passive: false });
      c.addEventListener('keydown', (e) => {
        const step = e.shiftKey ? 0.05 : 0.01;
        const moves = { ArrowLeft: [step, 0], ArrowRight: [-step, 0], ArrowUp: [0, step], ArrowDown: [0, -step] };
        if (moves[e.key]) { e.preventDefault(); this.adjust((s) => { s.cx += moves[e.key][0]; s.cy += moves[e.key][1]; }); }
        else if (e.key === '+' || e.key === '=') { e.preventDefault(); this.adjust((s) => { s.zoom = Math.min(3, s.zoom + 0.1); }); }
        else if (e.key === '-') { e.preventDefault(); this.adjust((s) => { s.zoom = Math.max(1, s.zoom - 0.1); }); }
      });
    }
    // apply a change to the active photo, keep it covering the magnet, redraw
    adjust(fn) {
      const s = this.current();
      if (!s) return;
      fn(s);
      const p = placement(s, 1);
      s.cx = (0.5 - p.x) / p.dw;
      s.cy = (0.5 - p.y) / p.dh;
      this.zoom.value = s.zoom;
      this.draw();
    }
    draw() {
      const s = this.current();
      this.magnet.hidden = !s;
      this.empty.hidden = !!s;
      this.tools.hidden = !s;
      this.hint.hidden = !s;
      if (this.warn) this.warn.hidden = !s || Math.min(s.w, s.h) / s.zoom >= MIN_SOURCE_PX;
      if (!s) return;
      const size = this.canvas.clientWidth;
      if (!size) return;
      const px = Math.round(size * Math.min(window.devicePixelRatio || 1, 2));
      if (this.canvas.width !== px) { this.canvas.width = px; this.canvas.height = px; }
      const g = this.canvas.getContext('2d');
      const p = placement(s, px);
      g.imageSmoothingQuality = 'high';
      g.clearRect(0, 0, px, px);
      g.drawImage(s.preview, p.x, p.y, p.dw, p.dh);
      this.paintThumb(this.active);
    }
    paintThumb(i) {
      const s = this.shots[i];
      const li = this.thumbs.children[i];
      if (!s || !li) return;
      const c = $('canvas', li);
      const g = c.getContext('2d');
      const p = placement(s, c.width);
      g.clearRect(0, 0, c.width, c.height);
      g.drawImage(s.preview, p.x, p.y, p.dw, p.dh);
      li.classList.toggle('is-low', Math.min(s.w, s.h) / s.zoom < MIN_SOURCE_PX);
    }
    renderThumbs() {
      const x = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>';
      const cells = this.shots.map((s, i) => `<li class="studio__thumb" aria-current="${i === this.active}">`
        + `<button type="button" class="studio__thumb-btn" data-pick="${i}" aria-label="${fmt(S.studioEdit, { number: i + 1 })}"><canvas width="160" height="160"></canvas></button>`
        + `<span class="studio__thumb-num" aria-hidden="true">${i + 1}</span>`
        + `<span class="studio__thumb-warn" title="${S.studioLowRes}" aria-hidden="true">!</span>`
        + `<button type="button" class="studio__thumb-remove" data-remove="${i}" aria-label="${fmt(S.studioRemove, { number: i + 1 })}">${x}</button></li>`);
      for (let i = this.shots.length; i < Math.min(this.target, 24); i++) cells.push(`<li class="studio__slot" aria-hidden="true">${i + 1}</li>`);
      this.thumbs.innerHTML = cells.join('');
      this.shots.forEach((s, i) => this.paintThumb(i));
      this.count.textContent = `${this.shots.length}/${this.target}`;
      this.drop.hidden = this.shots.length >= this.target;
    }
    select(i) {
      this.active = Math.max(-1, Math.min(i, this.shots.length - 1));
      $$('.studio__thumb', this.thumbs).forEach((li, k) => li.setAttribute('aria-current', String(k === this.active)));
      const s = this.current();
      if (s) this.zoom.value = s.zoom;
      this.draw();
    }
    remove(i) {
      this.shots.splice(i, 1);
      if (this.active >= this.shots.length) this.active = this.shots.length - 1;
      this.renderThumbs();
      this.select(this.active);
    }
    async addFiles(files) {
      this.say('');
      const room = Math.max(0, this.target - this.shots.length);
      for (const file of files.slice(0, room)) {
        if (file.size > this.maxBytes) { this.say(S.fileTooBig); continue; }
        try {
          const d = await decodeImage(file);
          const k = Math.min(1, 1400 / Math.max(d.w, d.h));
          const preview = document.createElement('canvas');
          preview.width = Math.max(1, Math.round(d.w * k));
          preview.height = Math.max(1, Math.round(d.h * k));
          preview.getContext('2d').drawImage(d.src, 0, 0, preview.width, preview.height);
          d.release();
          this.shots.push({ file, preview, w: d.w, h: d.h, zoom: 1, cx: 0.5, cy: 0.5 });
          this.active = this.shots.length - 1;
        } catch (e) {
          this.say(fmt(S.studioBadFile, { file: file.name }));
        }
      }
      this.drop.classList.remove('has-error');
      this.renderThumbs();
      this.select(this.active);
    }
    setVariant(variant, units) {
      this.target = Math.max(1, units);
      if (this.shots.length > this.target) this.shots.length = this.target;
      if (this.active >= this.shots.length) this.active = this.shots.length - 1;
      const price = formatMoney(variant.price);
      this.summary.textContent = `${this.page.product.title} — ${variant.title} · ${price}`;
      this.addLabel.textContent = fmt(S.studioAdd, { price });
      this.renderThumbs();
      if (this.dialog.open) this.select(this.active);
    }
    open(trigger) {
      this.trigger = trigger || document.activeElement;
      document.documentElement.style.overflow = 'hidden';
      if (typeof this.dialog.showModal === 'function') { if (!this.dialog.open) this.dialog.showModal(); }
      else this.dialog.setAttribute('open', '');
      this.dialog.scrollTop = 0;
      this.renderThumbs();
      this.select(this.active);
    }
    close() {
      if (typeof this.dialog.close === 'function') this.dialog.close();
      else this.dialog.removeAttribute('open');
      this.dialog.dispatchEvent(new Event('close'));
    }
    reset() {
      this.shots = [];
      this.active = -1;
      this.ok.checked = false;
      $$('input', this.share).forEach((i) => { i.checked = false; });
      this.renderThumbs();
      this.draw();
    }
    async render(shot, n) {
      let d = null;
      try { d = await decodeImage(shot.file); } catch (e) { d = null; }
      const c = document.createElement('canvas');
      c.width = PRINT_PX;
      c.height = PRINT_PX;
      const g = c.getContext('2d');
      g.imageSmoothingQuality = 'high';
      const p = placement(shot, PRINT_PX);
      g.drawImage(d ? d.src : shot.preview, p.x, p.y, p.dw, p.dh);
      if (d) d.release();
      const blob = await new Promise((r) => c.toBlob(r, 'image/jpeg', 0.92));
      c.width = 0;
      c.height = 0;
      if (!blob) throw new Error(S.cartError);
      return new File([blob], `photo-${n}.jpg`, { type: 'image/jpeg' });
    }
    async submit(submitter) {
      let bad = null;
      const fail = (el, msg) => { el.classList.add('has-error'); if (!bad) { bad = el; this.say(msg); } };
      if (this.shots.length < this.target) fail(this.drop.hidden ? this.thumbs : this.drop, S.missingPhotos);
      if (!$('input:checked', this.share)) fail(this.share, S.studioMissingShare);
      if (!this.ok.checked) fail(this.confirm, S.studioMissingConfirm);
      if (bad) { bad.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'center' }); return; }
      this.say('');
      const button = submitter && this.buttons.includes(submitter) ? submitter : this.buttons[0];
      const label = $('span', button);
      const prev = label.textContent;
      this.buttons.forEach((b) => { b.disabled = true; });
      label.textContent = S.studioPreparing;
      try {
        const fd = new FormData(this.page.form);
        for (const [i, shot] of this.shots.entries()) fd.append(`properties[Photo ${i + 1}]`, await this.render(shot, i + 1));
        label.textContent = S.adding;
        fd.append('sections', CART_SECTIONS.join(','));
        fd.append('sections_url', window.location.pathname);
        const data = await cartRequest(`${T.routes.cartAdd}.js`, fd, true);
        this.reset();
        this.close();
        if (button.hasAttribute('data-keep-shopping')) { applySections(data.sections); toast(S.studioAdded); }
        else await afterAdd(data);
      } catch (err) {
        this.say(err.message || S.cartError);
      } finally {
        this.buttons.forEach((b) => { b.disabled = false; });
        label.textContent = prev;
      }
    }
  }

  /* ---------------- product ---------------- */
  class ProductPage {
    constructor(root) {
      this.root = root;
      const json = $('[data-product-json]', root);
      this.product = json ? JSON.parse(json.textContent) : null;
      this.form = $('form[data-product-form]', root);
      if (!this.product || !this.form) return;
      this.idInput = $('input[name="id"]', this.form);
      this.submit = $('[data-add-to-cart]', this.form);
      this.initOptions();
      this.initSwatches();
      this.initUploads();
      this.initBranding();
      this.initDesigns();
      this.initStudio();
      this.initGallery();
      this.initSticky();
      this.form.addEventListener('submit', (e) => this.onSubmit(e));
      this.update(this.currentVariant(), false);
    }
    currentVariant() {
      const selected = $$('[data-option-index]', this.root).map((fs) => {
        const checked = $('input:checked', fs) || $('select', fs);
        return checked ? checked.value : null;
      });
      if (!selected.length) return this.product.variants.find((v) => String(v.id) === this.idInput.value) || this.product.variants[0];
      return this.product.variants.find((v) => v.options.every((o, i) => o === selected[i])) || null;
    }
    initOptions() {
      $$('[data-option-index]', this.root).forEach((fs) => fs.addEventListener('change', () => this.update(this.currentVariant(), true)));
    }
    unitsOf(variant) {
      if (!variant) return 1;
      const m = String(variant.title).match(/(\d+)/);
      return m ? Number(m[1]) : 1;
    }
    update(variant, pushUrl) {
      const priceEls = $$('[data-price]', this.root);
      if (!variant) {
        if (this.submit) {
          this.submit.disabled = true;
          this.submit.querySelector('span').textContent = S.unavailable;
        }
        return;
      }
      this.idInput.value = variant.id;
      priceEls.forEach((el) => { el.textContent = formatMoney(variant.price); });
      $$('[data-compare-price]', this.root).forEach((el) => { el.textContent = variant.compare_at_price > variant.price ? formatMoney(variant.compare_at_price) : ''; el.hidden = !(variant.compare_at_price > variant.price); });
      const fieldsets = $$('[data-option-index]', this.root);
      fieldsets.forEach((fs, i) => { const out = $('[data-selected-value]', fs); if (out) out.textContent = variant.options[i]; });
      if (fieldsets.length > 1) {
        // prices on the last option's pills follow the other options (e.g. Style → Quantity)
        const li = fieldsets.length - 1;
        $$('.pill-option', fieldsets[li]).forEach((pill) => {
          const small = $('[data-pill-price]', pill);
          if (!small) return;
          const value = $('input', pill).value;
          const match = this.product.variants.find((v) => v.options.every((o, i) => (i === li ? o === value : o === variant.options[i])));
          small.textContent = match ? formatMoney(match.price) : '';
        });
      }
      const units = this.unitsOf(variant);
      const unitEl = $('[data-unit-price]', this.root);
      if (unitEl) {
        const perUnit = this.root.dataset.unitPricing === 'true' && units > 1;
        unitEl.hidden = !perUnit;
        if (perUnit) unitEl.textContent = `${formatMoney(Math.round(variant.price / units))} ${S.each}`;
      }
      if (this.submit) {
        this.submit.disabled = !variant.available;
        this.submit.querySelector('span').textContent = variant.available ? S.addToCart : S.soldOut;
      }
      const sticky = $('[data-sticky-buy]');
      if (sticky) { const sp = $('[data-sticky-price]', sticky); if (sp) sp.textContent = formatMoney(variant.price); }
      if (this.studio) {
        this.studio.setVariant(variant, units);
        $$('[data-studio-open]', this.root).forEach((b) => {
          b.disabled = !variant.available;
          const l = $('[data-studio-open-label]', b);
          if (l) l.textContent = variant.available ? fmt(S.studioOpen, { price: formatMoney(variant.price) }) : S.soldOut;
        });
      }
      if (variant.featured_media && this.goToMedia) this.goToMedia(variant.featured_media.id);
      if (pushUrl && window.history.replaceState) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
    }
    initSwatches() {
      $$('[data-swatch-group]', this.root).forEach((group) => {
        const out = $('[data-swatch-value]', group);
        group.addEventListener('change', (e) => { if (out && e.target.checked) out.textContent = e.target.value; group.classList.remove('has-error'); });
      });
      $$('[data-required-group]', this.root).forEach((g) => g.addEventListener('change', () => g.classList.remove('has-error')));
    }
    initUploads() {
      $$('[data-upload]', this.root).forEach((field) => {
        const input = $('input[type="file"]', field);
        const zone = $('.dropzone', field);
        const preview = $('[data-upload-preview]', field);
        const max = (T.uploadMaxMb || 15) * 1024 * 1024;
        const show = () => {
          const file = input.files && input.files[0];
          field.classList.remove('has-error');
          if (!file) { preview.hidden = true; zone.hidden = false; return; }
          if (file.size > max) { input.value = ''; toast(S.fileTooBig); preview.hidden = true; zone.hidden = false; return; }
          const isImg = /^image\//.test(file.type) && !/svg|heic|heif/.test(file.type);
          preview.innerHTML = `${isImg ? `<img alt="" src="${URL.createObjectURL(file)}">` : `<span class="file-thumb">${(file.name.split('.').pop() || 'file').toUpperCase().slice(0, 4)}</span>`}<span>${file.name.replace(/</g, '&lt;')}</span><button type="button" class="btn btn--sm btn--ghost" data-upload-clear>${preview.dataset.removeLabel || 'Remove'}</button>`;
          preview.hidden = false;
          zone.hidden = true;
        };
        input.addEventListener('change', show);
        preview.addEventListener('click', (e) => { if (e.target.closest('[data-upload-clear]')) { input.value = ''; show(); } });
        ['dragenter', 'dragover'].forEach((ev) => zone.addEventListener(ev, () => zone.classList.add('is-over')));
        ['dragleave', 'drop'].forEach((ev) => zone.addEventListener(ev, () => zone.classList.remove('is-over')));
      });
    }
    // big photos → max 2000 px (JPEG stays JPEG, PNG keeps transparency); PDFs and small files untouched
    async shrink(file) {
      if (!/^image\/(jpe?g|png|webp)$/.test(file.type) || !window.createImageBitmap) return file;
      try {
        const bmp = await createImageBitmap(file);
        const scale = Math.min(1, 2000 / Math.max(bmp.width, bmp.height));
        if (scale === 1 && file.size < 2 * 1024 * 1024) { bmp.close && bmp.close(); return file; }
        const c = document.createElement('canvas');
        c.width = Math.round(bmp.width * scale);
        c.height = Math.round(bmp.height * scale);
        c.getContext('2d').drawImage(bmp, 0, 0, c.width, c.height);
        bmp.close && bmp.close();
        const png = file.type === 'image/png';
        const blob = await new Promise((r) => c.toBlob(r, png ? 'image/png' : 'image/jpeg', 0.9));
        return blob ? new File([blob], file.name.replace(/\.\w+$/, png ? '.png' : '.jpg'), { type: blob.type }) : file;
      } catch (e) { return file; }
    }
    // logo OR text: only the chosen panel is enabled, visible and required
    initBranding() {
      const box = $('[data-logo-or-text]', this.root);
      if (!box) return;
      const apply = () => {
        const mode = ($('[data-brand-mode]:checked', box) || {}).dataset.brandMode || 'logo';
        $$('[data-brand-panel]', box).forEach((panel) => {
          const on = panel.dataset.brandPanel === mode;
          panel.hidden = !on;
          panel.classList.remove('has-error');
          $$('input', panel).forEach((i) => { i.disabled = !on; });
          if (panel.dataset.brandPanel === 'logo') panel.toggleAttribute('data-required', on);
          else if (on) panel.setAttribute('data-required-text', box.dataset.textLabel || 'Text'); else panel.removeAttribute('data-required-text');
        });
      };
      box.dataset.textLabel = ($('[data-brand-panel="text"] .field__label', box) || {}).textContent || 'Text';
      box.addEventListener('change', (e) => { if (e.target.matches('[data-brand-mode]')) apply(); });
      apply();
    }
    // up to N design files (photos, drawings, PDFs) sent as "Design 1", "Design 2"…
    initDesigns() {
      this.designs = [];
      this.designBox = $('[data-designs]', this.root);
      if (!this.designBox) return;
      const input = $('[data-designs-input]', this.designBox);
      const list = $('[data-designs-list]', this.designBox);
      const cta = $('[data-designs-cta]', this.designBox);
      const max = Number(this.designBox.dataset.max || 5);
      const maxBytes = (T.uploadMaxMb || 15) * 1024 * 1024;
      const render = () => {
        list.innerHTML = this.designs.map((f, i) => {
          const isImg = /^image\//.test(f.type) && !/heic|heif|svg/.test(f.type);
          const thumb = isImg ? `<img alt="" src="${f._url || (f._url = URL.createObjectURL(f))}">` : `<span class="file-thumb">${(f.name.split('.').pop() || 'file').toUpperCase().slice(0, 4)}</span>`;
          return `<li class="dropzone__file">${thumb}<span>${f.name.replace(/</g, '&lt;')}</span><button type="button" class="btn btn--sm btn--ghost" data-design-remove="${i}">${S.removeFile || 'Remove'}</button></li>`;
        }).join('');
        cta.hidden = this.designs.length >= max;
      };
      input.addEventListener('change', () => {
        for (const f of Array.from(input.files || [])) {
          if (this.designs.length >= max) { toast(S.designsFull); break; }
          if (f.size > maxBytes) { toast(S.fileTooBig); continue; }
          this.designs.push(f);
        }
        input.value = '';
        this.designBox.classList.remove('has-error');
        $$('[data-require-one]', this.root).forEach((g) => g.classList.remove('has-error'));
        render();
      });
      list.addEventListener('click', (e) => {
        const b = e.target.closest('[data-design-remove]');
        if (b) { this.designs.splice(Number(b.dataset.designRemove), 1); render(); }
      });
      ['dragenter', 'dragover'].forEach((ev) => cta.addEventListener(ev, () => cta.classList.add('is-over')));
      ['dragleave', 'drop'].forEach((ev) => cta.addEventListener(ev, () => cta.classList.remove('is-over')));
      render();
    }
    initStudio() {
      const dialog = $('[data-studio]', this.root);
      if (!dialog) return;
      this.studio = new PhotoStudio(this, dialog);
      $$('[data-studio-open]', this.root).forEach((b) => b.addEventListener('click', () => this.studio.open(b)));
    }
    validate() {
      let firstBad = null;
      const fail = (el, msg) => { el.classList.add('has-error'); if (!firstBad) { firstBad = el; toast(msg); } };
      $$('[data-required-group]', this.root).forEach((g) => { if (!$('input:checked', g)) fail(g, fmt(S.missingField, { field: g.dataset.requiredGroup })); });
      $$('[data-required-text]', this.root).forEach((f) => { const i = $('input, textarea', f); if (!i.value.trim()) fail(f, fmt(S.missingText || S.missingField, { field: f.dataset.requiredText })); });
      $$('[data-upload][data-required]', this.root).forEach((f) => { const i = $('input[type="file"]', f); if (!i.files || !i.files.length) fail(f, S.missingUpload); });
      $$('[data-require-one]', this.root).forEach((f) => {
        const text = $('textarea, input', f);
        if (!(this.designs && this.designs.length) && !(text && text.value.trim())) { if (this.designBox) this.designBox.classList.add('has-error'); fail(f, S.missingDesign); }
      });
      if (firstBad) firstBad.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'center' });
      return !firstBad;
    }
    async onSubmit(e) {
      e.preventDefault();
      if (this.studio) { this.studio.submit(e.submitter); return; }
      if (!this.validate()) return;
      this.submit.disabled = true;
      const label = this.submit.querySelector('span');
      const prev = label.textContent;
      label.textContent = S.adding;
      try {
        const fd = new FormData(this.form);
        for (const [i, f] of (this.designs || []).entries()) fd.append(`properties[Design ${i + 1}]`, await this.shrink(f));
        fd.append('sections', CART_SECTIONS.join(','));
        fd.append('sections_url', window.location.pathname);
        const data = await cartRequest(`${T.routes.cartAdd}.js`, fd, true);
        await afterAdd(data);
      } catch (err) {
        toast(err.message || S.cartError);
      } finally {
        this.submit.disabled = false;
        label.textContent = prev;
      }
    }
    initGallery() {
      const gallery = $('[data-gallery]', this.root);
      if (!gallery) return;
      const track = $('[data-gallery-track]', gallery);
      const slides = $$('[data-media-id]', track);
      const thumbs = $$('[data-thumb]', gallery);
      const dots = $$('[data-dot]', gallery);
      const counter = $('[data-gallery-counter]', gallery);
      const setActive = (i) => {
        thumbs.forEach((t, k) => t.setAttribute('aria-current', k === i ? 'true' : 'false'));
        dots.forEach((d, k) => d.setAttribute('aria-current', k === i ? 'true' : 'false'));
        if (counter) counter.textContent = `${i + 1} / ${slides.length}`;
        this.activeSlide = i;
      };
      const go = (i) => {
        const s = slides[Math.max(0, Math.min(slides.length - 1, i))];
        if (s) track.scrollTo({ left: s.offsetLeft - track.offsetLeft, behavior: reduced ? 'auto' : 'smooth' });
      };
      this.goToMedia = (id) => { const i = slides.findIndex((s) => s.dataset.mediaId === String(id)); if (i >= 0) go(i); };
      thumbs.forEach((t, i) => t.addEventListener('click', () => go(i)));
      dots.forEach((d, i) => d.addEventListener('click', () => go(i)));
      $('[data-gallery-prev]', gallery)?.addEventListener('click', () => go((this.activeSlide || 0) - 1));
      $('[data-gallery-next]', gallery)?.addEventListener('click', () => go((this.activeSlide || 0) + 1));
      const io = new IntersectionObserver((entries) => entries.forEach((en) => { if (en.isIntersecting && en.intersectionRatio > 0.6) setActive(slides.indexOf(en.target)); }), { root: track, threshold: [0.6] });
      slides.forEach((s) => io.observe(s));
      setActive(0);
    }
    initSticky() {
      const bar = $('[data-sticky-buy]');
      const anchor = this.submit || $('[data-studio-open]', this.root);
      if (!bar || !anchor) return;
      const io = new IntersectionObserver(([en]) => {
        const past = en.boundingClientRect.top < 0;
        bar.classList.toggle('is-visible', !en.isIntersecting && past);
      });
      io.observe(anchor);
      $('[data-sticky-go]', bar)?.addEventListener('click', (e) => {
        if (this.studio) { this.studio.open(e.currentTarget); return; }
        const target = $('[data-personalise]', this.root) || this.form;
        const needs = $$('[data-required-group], [data-required-text], [data-upload][data-required], [data-require-one]', this.root).length > 0;
        if (needs) target.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'start' });
        else this.form.requestSubmit ? this.form.requestSubmit() : this.submit.click();
      });
    }
  }
  $$('[data-product-page]').forEach((el) => new ProductPage(el));

  /* ---------------- welcome offer popup ---------------- */
  (() => {
    const dlg = $('[data-promo]');
    if (!dlg || typeof dlg.showModal !== 'function') return;
    const KEY = 'ohm-promo';
    const read = () => { try { return JSON.parse(localStorage.getItem(KEY) || '{}'); } catch (e) { return {}; } };
    const write = (v) => { try { localStorage.setItem(KEY, JSON.stringify({ ...read(), ...v })); } catch (e) { /* private mode */ } };
    const done = () => { $('[data-promo-step="form"]', dlg).hidden = true; $('[data-promo-step="done"]', dlg).hidden = false; };
    const open = () => { if (!dlg.open && !$('dialog[open]')) { dlg.showModal(); document.documentElement.style.overflow = 'hidden'; } };
    // don't rely on the dialog's async "close" event (delayed in background tabs): settle state right here
    const settle = () => {
      if (!$('.drawer.is-open')) document.documentElement.style.overflow = '';
      if (!read().subscribed) write({ dismissedAt: Date.now() });
    };
    const close = () => { settle(); if (dlg.open) dlg.close(); };
    dlg.addEventListener('cancel', settle); // Esc
    dlg.addEventListener('click', (e) => { if (e.target === dlg || e.target.closest('[data-promo-close]')) close(); });
    const copy = $('[data-promo-copy]', dlg);
    copy?.addEventListener('click', async () => {
      try { await navigator.clipboard.writeText($('[data-promo-code]', dlg).textContent.trim()); copy.textContent = copy.dataset.copied || 'Copied!'; } catch (e) { /* clipboard blocked */ }
    });
    document.addEventListener('promo:subscribed', () => { write({ subscribed: true }); done(); open(); });
    // theme editor: open while the section is selected, never on a timer
    if (window.Shopify && window.Shopify.designMode) {
      const mine = (e) => dlg.closest('.shopify-section')?.id === `shopify-section-${e.detail.sectionId}`;
      document.addEventListener('shopify:section:select', (e) => { if (mine(e)) open(); });
      document.addEventListener('shopify:section:deselect', (e) => { if (mine(e) && dlg.open) close(); });
      return;
    }
    // back from Shopify's customer form: ?customer_posted=true#PromoForm (errors come back without customer_posted)
    if (location.hash === '#PromoForm') {
      if (new URLSearchParams(location.search).get('customer_posted') === 'true') { write({ subscribed: true }); done(); }
      open();
      return;
    }
    const st = read();
    if (st.subscribed) return;
    if (st.dismissedAt && Date.now() - st.dismissedAt < Number(dlg.dataset.snoozeDays || 7) * 864e5) return;
    if (dlg.dataset.mobile === 'false' && window.matchMedia('(max-width: 749px)').matches) return;
    if (/^\/(cart|checkout|challenge|password|account)/.test(location.pathname)) return;
    const timer = setTimeout(open, Number(dlg.dataset.delay || 6) * 1000);
    if (finePointer) {
      const exit = (e) => { if (!e.relatedTarget && e.clientY < 8) { clearTimeout(timer); open(); document.removeEventListener('mouseout', exit); } };
      document.addEventListener('mouseout', exit);
    }
  })();

  /* ---------------- recommendations ---------------- */
  $$('[data-recommendations]').forEach(async (el) => {
    if (el.querySelector('.product-grid')) return;
    try {
      const res = await fetch(el.dataset.url);
      const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
      const fresh = doc.querySelector('[data-recommendations]');
      if (fresh && fresh.querySelector('.product-grid')) el.innerHTML = fresh.innerHTML;
    } catch (e) { /* ignore */ }
  });

  /* ---------------- rails ---------------- */
  $$('[data-rail]').forEach((rail) => {
    const track = $('[data-rail-track]', rail);
    const section = rail.closest('section') || rail.parentElement;
    const prev = $('[data-rail-prev]', section);
    const next = $('[data-rail-next]', section);
    const progress = $('[data-rail-progress]', rail);
    const update = () => {
      const max = track.scrollWidth - track.clientWidth;
      if (prev) prev.disabled = track.scrollLeft <= 4;
      if (next) next.disabled = track.scrollLeft >= max - 4;
      if (progress) {
        const ratio = track.clientWidth / track.scrollWidth;
        progress.style.setProperty('--p', `${Math.max(12, ratio * 100)}%`);
        const pos = max > 0 ? track.scrollLeft / max : 0;
        progress.style.setProperty('--x', `${pos * ((1 / Math.max(ratio, 0.12)) - 1) * 100}%`);
      }
    };
    const step = () => track.clientWidth * 0.85;
    prev && prev.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: reduced ? 'auto' : 'smooth' }));
    next && next.addEventListener('click', () => track.scrollBy({ left: step(), behavior: reduced ? 'auto' : 'smooth' }));
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', debounce(update, 150));
    update();
  });

  /* ---------------- collection filters & sort ---------------- */
  // delegated so it keeps working when the section is re-rendered
  document.addEventListener('change', (e) => {
    const facetForm = e.target.closest('[data-facets]');
    if (facetForm && e.target.matches('input[type="checkbox"]')) {
      const params = new URLSearchParams(new FormData(facetForm));
      for (const [k, v] of [...params.entries()]) if (v === '') params.delete(k);
      window.location.search = params.toString();
      return;
    }
    const sort = e.target.closest('[data-sort]');
    if (sort) {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', sort.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    }
  });

  /* ---------------- product page quantity (non-cart) ---------------- */
  // handled by the generic [data-qty] listener above (dispatches change)

  /* ---------------- reveal on scroll ---------------- */
  const reveal = $$('[data-reveal]');
  if (T.reveal && reveal.length && 'IntersectionObserver' in window && !reduced) {
    const io = new IntersectionObserver((entries) => entries.forEach((en) => {
      if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
    }), { rootMargin: '0px 0px -6% 0px', threshold: 0.08 });
    reveal.forEach((el) => {
      const r = el.getBoundingClientRect();
      if (r.top < window.innerHeight && r.bottom > 0) el.classList.add('is-in');
      else io.observe(el);
    });
    // failsafe: never leave content hidden (anchors, print, slow devices)
    const showAll = () => reveal.forEach((el) => el.classList.add('is-in'));
    window.addEventListener('hashchange', showAll);
    window.addEventListener('beforeprint', showAll);
    setTimeout(() => { if (window.scrollY > 0) reveal.forEach((el) => { if (el.getBoundingClientRect().top < window.innerHeight) el.classList.add('is-in'); }); }, 1200);
  } else {
    reveal.forEach((el) => el.classList.add('is-in'));
  }

  /* ---------------- collage parallax ---------------- */
  if (finePointer && !reduced) {
    $$('[data-parallax]').forEach((box) => {
      const layers = $$('[data-depth]', box);
      let raf = 0;
      box.parentElement.addEventListener('pointermove', (e) => {
        const r = box.getBoundingClientRect();
        const x = (e.clientX - r.left) / r.width - 0.5;
        const y = (e.clientY - r.top) / r.height - 0.5;
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(() => layers.forEach((l) => {
          const d = Number(l.dataset.depth) || 10;
          l.style.setProperty('--px', `${(-x * d).toFixed(1)}px`);
          l.style.setProperty('--py', `${(-y * d).toFixed(1)}px`);
        }));
      });
      box.parentElement.addEventListener('pointerleave', () => layers.forEach((l) => { l.style.setProperty('--px', '0px'); l.style.setProperty('--py', '0px'); }));
    });
  }
})();
